// 딥링크 처리 유틸리티
class DeepLinkHandler {
  constructor() {
    this.packageName = 'com.geongi.kr.myapp';
    this.appScheme = 'geongiapp';
    
    // 더 포괄적인 Android 감지 (Samsung Browser 포함)
    const ua = navigator.userAgent.toLowerCase();
    this.isAndroid = /android/i.test(ua) || 
                     /mobile/i.test(ua) && /linux/i.test(ua) ||
                     /samsungbrowser/i.test(ua);
    
    // iOS 감지
    this.isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;
    
    // 모바일 감지 (태블릿 포함)
    this.isMobile = this.isAndroid || this.isIOS || 
                    /webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent);
    
    // 디버깅 로그
    console.log('[DeepLink Init]', {
      userAgent: navigator.userAgent,
      isAndroid: this.isAndroid,
      isIOS: this.isIOS,
      isMobile: this.isMobile
    });
  }

  // 현재 URL을 앱에서 열도록 시도 (다이얼로그 없이)
  openInApp(customUrl = null) {
    if (!this.isMobile) {
      console.log('Not a mobile device, staying on web');
      return false;
    }

    const targetUrl = customUrl || window.location.href;
    
    if (this.isAndroid) {
      this.openAndroidApp(targetUrl);
    }
    // iOS는 추후 구현 가능
    
    return true;
  }

  // Android 앱 열기 시도 (Intent URL로 직접 실행)
  openAndroidApp(url) {
    console.log('[DeepLink] Attempting to open app with Intent URL');
    
    const intentUrl = this.buildIntentUrl(url);
    
    // Intent URL로 앱 실행 시도 (다이얼로그 없이)
    this.launchAppDirectly(intentUrl);
  }
  
  // Intent URL로 앱 직접 실행 (다이얼로그 없이)
  launchAppDirectly(intentUrl) {
    console.log('[DeepLink] Launching app with Intent URL:', intentUrl);
    
    // iframe으로 Intent URL 실행
    const launchFrame = document.createElement('iframe');
    launchFrame.style.cssText = 'display:none;width:0;height:0;border:0;';
    document.body.appendChild(launchFrame);
    
    // Intent URL 설정
    launchFrame.src = intentUrl;
    
    // 1초 후 iframe 제거 (앱 실행 여부와 무관하게)
    setTimeout(() => {
      if (launchFrame.parentNode) {
        document.body.removeChild(launchFrame);
      }
      console.log('[DeepLink] Intent URL execution completed');
    }, 1000);
  }
  
  // 사용하지 않음 - deprecated
  _deprecated_checkAndShowDialog(webUrl, intentUrl, customSchemeUrl) {
    console.log('[DeepLink] Starting app detection...');
    
    // 방법 1: Intent URI로 앱 확인 (더 안정적)
    const checkIntent = () => {
      const testFrame = document.createElement('iframe');
      testFrame.style.display = 'none';
      testFrame.style.width = '0';
      testFrame.style.height = '0';
      document.body.appendChild(testFrame);
      
      let appDetected = false;
      const startTime = Date.now();
      
      // 페이지 비저빌리티 변화 감지
      const handleVisibilityChange = () => {
        const timeDiff = Date.now() - startTime;
        // 500ms 이내에 페이지가 숨겨지면 앱이 있는 것으로 판단
        if (document.hidden && timeDiff < 500) {
          appDetected = true;
          console.log('[DeepLink] App detected via visibility change');
        }
      };
      
      // blur 이벤트도 감지 (앱으로 전환 시)
      const handleBlur = () => {
        const timeDiff = Date.now() - startTime;
        if (timeDiff < 500) {
          appDetected = true;
          console.log('[DeepLink] App detected via window blur');
        }
      };
      
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('blur', handleBlur);
      
      // Intent URI로 앱 확인 시도
      const checkIntentUrl = 
        `intent://check#Intent;` +
        `scheme=https;` +
        `package=${this.packageName};` +
        `end`;
      
      console.log('[DeepLink] Checking app with intent:', checkIntentUrl);
      testFrame.src = checkIntentUrl;
      
      // 300ms 후 확인 (충분한 시간 제공)
      setTimeout(() => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('blur', handleBlur);
        
        // iframe 제거
        if (testFrame.parentNode) {
          document.body.removeChild(testFrame);
        }
        
        // 페이지가 여전히 visible이고 포커스가 있으면 앱 없음
        if (!appDetected && !document.hidden && document.hasFocus()) {
          console.log('[DeepLink] App not detected after intent check');
          // 방법 2: Custom scheme으로 재확인
          checkCustomScheme();
        } else if (appDetected) {
          console.log('[DeepLink] App confirmed - showing dialog');
          // 앱이 있으므로 다이얼로그 표시
          sessionStorage.setItem('deeplink_dialog_shown', 'true');
          // 페이지가 다시 포커스 받을 때까지 대기
          setTimeout(() => {
            if (!document.hidden) {
              this.showAppChoiceDialog(webUrl, intentUrl, customSchemeUrl);
            }
          }, 500);
        }
      }, 300);
    };
    
    // 방법 2: Custom scheme으로 확인 (fallback)
    const checkCustomScheme = () => {
      const checkFrame = document.createElement('iframe');
      checkFrame.style.display = 'none';
      document.body.appendChild(checkFrame);
      
      let appDetected = false;
      const startTime = Date.now();
      
      const handleVisibilityChange = () => {
        const timeDiff = Date.now() - startTime;
        if (document.hidden && timeDiff < 300) {
          appDetected = true;
        }
      };
      
      document.addEventListener('visibilitychange', handleVisibilityChange);
      
      console.log('[DeepLink] Checking app with custom scheme: geongiapp://check');
      checkFrame.src = 'geongiapp://check';
      
      setTimeout(() => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        
        if (checkFrame.parentNode) {
          document.body.removeChild(checkFrame);
        }
        
        if (!appDetected && !document.hidden) {
          console.log('[DeepLink] App not installed - not showing dialog');
          sessionStorage.setItem('deeplink_app_not_installed', 'true');
        } else if (appDetected) {
          console.log('[DeepLink] App detected via custom scheme - showing dialog');
          sessionStorage.setItem('deeplink_dialog_shown', 'true');
          setTimeout(() => {
            if (!document.hidden) {
              this.showAppChoiceDialog(webUrl, intentUrl, customSchemeUrl);
            }
          }, 500);
        }
      }, 200);
    };
    
    // Intent URI로 먼저 시도
    checkIntent();
  }
  
  // 사용하지 않음 - deprecated
  _deprecated_showAppChoiceDialog(webUrl, intentUrl, customSchemeUrl) {
    // 기존 다이얼로그가 있으면 제거
    const existingDialog = document.getElementById('deeplink-dialog');
    if (existingDialog) {
      existingDialog.remove();
    }
    
    // 다이얼로그 HTML 생성
    const dialogHtml = `
      <div id="deeplink-dialog" style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999999;
        animation: fadeIn 0.2s ease-in;
      ">
        <div style="
          background: white;
          border-radius: 12px;
          padding: 24px;
          max-width: 90%;
          width: 320px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
          animation: slideUp 0.3s ease-out;
        ">
          <div style="
            display: flex;
            align-items: center;
            margin-bottom: 16px;
          ">
            <img src="/images/logo-geongi.png" style="
              width: 40px;
              height: 40px;
              margin-right: 12px;
              border-radius: 8px;
            " alt="앱 아이콘" onerror="this.style.display='none'">
            <h3 style="
              margin: 0;
              font-size: 18px;
              font-weight: 600;
              color: #1f2937;
            ">건기프로젝트 앱으로 열기</h3>
          </div>
          
          <p style="
            margin: 0 0 20px 0;
            color: #6b7280;
            font-size: 14px;
            line-height: 1.5;
          ">건기프로젝트 앱이 설치되어 있다면<br>앱에서 더 편리하게 이용하실 수 있습니다.</p>
          
          <div style="
            display: flex;
            gap: 10px;
          ">
            <button id="open-app-btn" style="
              flex: 1;
              padding: 12px;
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 15px;
              font-weight: 500;
              cursor: pointer;
              transition: transform 0.2s;
            " onmouseover="this.style.transform='scale(1.02)'" onmouseout="this.style.transform='scale(1)'">
              앱으로 열기
            </button>
            <button id="stay-web-btn" style="
              flex: 1;
              padding: 12px;
              background: #f3f4f6;
              color: #374151;
              border: none;
              border-radius: 8px;
              font-size: 15px;
              font-weight: 500;
              cursor: pointer;
              transition: background-color 0.2s;
            " onmouseover="this.style.backgroundColor='#e5e7eb'" onmouseout="this.style.backgroundColor='#f3f4f6'">
              웹으로 계속
            </button>
          </div>
        </div>
      </div>
      
      <style>
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { 
            transform: translateY(20px);
            opacity: 0;
          }
          to { 
            transform: translateY(0);
            opacity: 1;
          }
        }
      </style>
    `;
    
    // 다이얼로그를 body에 추가
    const dialogContainer = document.createElement('div');
    dialogContainer.innerHTML = dialogHtml;
    document.body.appendChild(dialogContainer.firstElementChild);
    
    // 버튼 이벤트 리스너
    document.getElementById('open-app-btn').addEventListener('click', () => {
      console.log('[DeepLink] User chose to open in app');
      // 앱 선택 표시
      sessionStorage.setItem('deeplink_app_opening', 'true');
      this.closeDialog();
      this.attemptAppOpen(intentUrl, customSchemeUrl);
    });
    
    document.getElementById('stay-web-btn').addEventListener('click', () => {
      console.log('[DeepLink] User chose to stay on web');
      // 선택 저장 - 웹을 선택한 경우 세션 동안 기억
      sessionStorage.setItem('deeplink_choice', 'web');
      this.closeDialog();
      // 웹에 머물기 - 아무 작업 안함
    });
    
    // 배경 클릭 시 닫기
    document.getElementById('deeplink-dialog').addEventListener('click', (e) => {
      if (e.target.id === 'deeplink-dialog') {
        this.closeDialog();
      }
    });
  }
  
  // 사용하지 않음 - deprecated
  _deprecated_closeDialog() {
    const dialog = document.getElementById('deeplink-dialog');
    if (dialog) {
      dialog.style.animation = 'fadeOut 0.2s ease-out';
      setTimeout(() => dialog.remove(), 200);
    }
  }
  
  // 사용하지 않음 - deprecated
  _deprecated_attemptAppOpen(intentUrl, customSchemeUrl) {
    // 페이지 숨김 상태 감지
    let appOpened = false;
    
    const handleVisibilityChange = () => {
      if (document.hidden) {
        appOpened = true;
        console.log('[DeepLink] App opened successfully - page hidden');
        // 앱이 열렸으므로 더 이상 시도하지 않음
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    // iframe으로 Intent URI 시도
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    
    console.log('[DeepLink] Attempting to open app with intent:', intentUrl);
    iframe.src = intentUrl;
    
    // 500ms 후 앱이 안 열렸으면 custom scheme 시도
    setTimeout(() => {
      if (!appOpened && !document.hidden) {
        console.log('[DeepLink] First attempt failed, trying custom scheme:', customSchemeUrl);
        window.location.href = customSchemeUrl;
      }
    }, 500);
    
    // 2초 후 정리 및 상태 확인
    setTimeout(() => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      
      // 앱이 열렸는지 최종 확인
      if (!appOpened && !document.hidden && document.visibilityState === 'visible') {
        console.log('[DeepLink] App not installed or failed to open');
        // 다이얼로그 표시 상태 리셋 (앱이 없는 경우)
        sessionStorage.removeItem('deeplink_dialog_shown');
        sessionStorage.removeItem('deeplink_app_opening');
      } else {
        console.log('[DeepLink] App opened successfully');
      }
    }, 2000);
  }

  // Intent URL 생성
  buildIntentUrl(webUrl) {
    // URL 파싱
    const url = new URL(webUrl);
    const path = url.pathname + url.search + url.hash;
    
    // Intent URI 생성 - browser_fallback_url 추가로 앱이 없으면 웹에 머물기
    const intentUrl = 
      `intent://${url.host}${path}#Intent;` +
      `scheme=https;` +
      `package=${this.packageName};` +
      `S.browser_fallback_url=${encodeURIComponent(webUrl)};` +
      `end`;
    
    console.log('[DeepLink] Intent URL built:', intentUrl);
    return intentUrl;
  }

  // 앱이 설치되지 않았을 때 처리
  handleAppNotInstalled() {
    // 선택적: 앱 다운로드 안내 토스트 표시
    if (window.showAppDownloadPrompt) {
      window.showAppDownloadPrompt();
    }
  }

  // 특정 페이지에 대한 딥링크 생성
  generateDeepLink(path, params = {}) {
    const baseUrl = 'https://2.youngsam.net';
    const queryString = new URLSearchParams(params).toString();
    const fullPath = queryString ? `${path}?${queryString}` : path;
    return `${baseUrl}${fullPath}`;
  }

  // SMS/이메일용 딥링크 생성
  generateShareableLink(type, id, additionalParams = {}) {
    const routes = {
      project: `/projects/${id}`,
      notice: `/notices/${id}`,
      help: `/help/${id}`,
      chat: `/projects/${id}?tab=chat`
    };

    const path = routes[type];
    if (!path) return null;

    return this.generateDeepLink(path, additionalParams);
  }

  // 페이지 로드 시 자동 앱 열기 시도 (선택적)
  attemptAutoOpen() {
    // URL 파라미터에 'prefer_app=true'가 있으면 자동으로 앱 열기 시도
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('prefer_app') === 'true' && this.isMobile) {
      // 약간의 지연 후 시도 (페이지 로드 완료 대기)
      setTimeout(() => {
        this.openInApp();
      }, 500);
    }
  }

  // 앱 설치 여부 체크 (대략적)
  async checkAppInstalled() {
    if (!this.isAndroid) return false;
    
    return new Promise((resolve) => {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      
      const timer = setTimeout(() => {
        document.body.removeChild(iframe);
        resolve(false);
      }, 1000);
      
      iframe.onload = () => {
        clearTimeout(timer);
        document.body.removeChild(iframe);
        resolve(false);
      };
      
      // 앱 스킴으로 체크 시도
      iframe.src = `${this.appScheme}://check`;
    });
  }
}

// 싱글톤 인스턴스 생성
const deepLinkHandler = new DeepLinkHandler();

export default deepLinkHandler;